import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/layout/Heading.styled';
import { Styled } from 'app/features/newLanding/components/HeroBlock/Perks/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const StoreDiscounts = () => (
  <Styled.Perk data-t="store-discount-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="gold">
      <path d="M11.35 6c1.5-3.86 4.29-6 8.65-6s7.15 2.14 8.65 6H37v34H3V6h8.35zm2.2 0h12.9A6.65 6.65 0 0020 2a6.65 6.65 0 00-6.46 4zm-2.82 2H5v30h30V8h-5.73c.5 2 .73 4.35.73 7h-2c0-2.75-.26-5.1-.8-7H12.8c-.54 1.9-.8 4.25-.8 7h-2c0-2.65.23-5 .73-7z" />
    </Styled.PerkIcon>
    <Heading as={Styled.PerkDescription} size="xxs">
      <FormattedMessage id="new_landing_store_discounts_perk" />
    </Heading>
    <Text
      as={Styled.PerkDescriptionMobile}
      size="xl"
      type="semibold"
      isFixedSize
    >
      <FormattedMessage id="new_landing_store_discounts_perk" />
    </Text>
  </Styled.Perk>
);

export default StoreDiscounts;
